import React from 'react';
import RegistrationForm from './RegistrationForm';

function App() {
    return (
        <div className="App">
            <RegistrationForm />
        </div>
    );
}

export default App;
